import React, { createContext, useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MsalProvider } from "@azure/msal-react";
import { msalB2CInstance, msalADInstance } from './config'
import { useLocation } from "react-router-dom";

const msalInstanceAD = msalADInstance;
const msalInstanceB2C = msalB2CInstance;

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const authType = localStorage.getItem("authType") ?? '';

  return (
    (authType === "b2c") ? <AuthContext.Provider >
      <MsalProvider instance={msalInstanceB2C}>{children}</MsalProvider>
    </AuthContext.Provider> :
      <AuthContext.Provider >
        <MsalProvider instance={msalADInstance}>{children}</MsalProvider>
      </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
